var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade bd-example-modal-lg",
      attrs: {
        id: "sailProformaStatusPopup",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "myLargeModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.agencyMap
              ? _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "contact-form-action" }, [
                    _c("div", { staticClass: "col-lg-12" }, [
                      _vm.sailAgencyProformaStatusList != null
                        ? _c(
                            "div",
                            { staticClass: "card-item" },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _vm._l(
                                _vm.sailAgencyProformaStatusList,
                                function (proformaStatus) {
                                  return _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contact-form-action col-sm-4",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-box" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "label-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.agencyMap[
                                                      proformaStatus.agencyId
                                                    ].name
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contact-form-action col-sm-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-box" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "label-text",
                                                class: _vm.getStatusClass(
                                                  proformaStatus.status
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getStatusText(
                                                      proformaStatus.status
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contact-form-action col-sm-2",
                                      },
                                      [
                                        proformaStatus.status !== "ok"
                                          ? _c(
                                              "div",
                                              { staticClass: "input-box" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "a-logo-export",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.createNewProforma(
                                                          proformaStatus.agencyId,
                                                          proformaStatus.sailId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Yarat")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        proformaStatus.status === "ok"
                                          ? _c(
                                              "div",
                                              { staticClass: "input-box" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "a-logo-export",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.createNewProforma(
                                                          proformaStatus.agencyId,
                                                          proformaStatus.sailId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Tekrar Yarat")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contact-form-action col-sm-2",
                                      },
                                      [
                                        proformaStatus.status === "ok"
                                          ? _c(
                                              "div",
                                              { staticClass: "input-box" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "a-logo-export",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadProforma(
                                                          proformaStatus
                                                            .agencyProforma
                                                            .documentStoreId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("indir")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contact-form-action col-sm-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-box" },
                                          [
                                            proformaStatus.agencyProforma
                                              ? _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "ddMMyyyyHHmmSS"
                                                        )(
                                                          proformaStatus
                                                            .agencyProforma
                                                            .createDate
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [_vm._v(" - ")]
                                                ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "contact-form-action ml-4" }),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "title mb-2 ml-3" }, [
        _vm._v("Sefer Proforma Durumu"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [
          _c("span", {
            staticClass: "la la-close",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "contact-form-action col-sm-4" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Acente Adı"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form-action col-sm-2" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Durumu"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form-action col-sm-2" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Aktar"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form-action col-sm-2" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("İndir"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form-action col-sm-2" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Üretim Tarihi"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }